module.exports = __webpack_public_path__ + "static/media/al.c521e40e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/al.svg
// module id = 803
// module chunks = 0